import { makeStyles } from "@material-ui/core";

export const useDeliveryTicketStyles = makeStyles((theme) => ({
	input: {
		"& .MuiInputBase-input": {
			fontSize: "17px !important",
			color: theme.palette.text.primary,
		},

		"& .MuiOutlinedInput-root": {
			"& fieldset": {},
			"&:hover fieldset": {
				borderColor: theme.palette.primary.dark,
			},
		},
	},
	disabledInput: {
		"& .MuiInputBase-input": {
			backgroundColor: " #e9ecef",
		},
		"& .MuiOutlinedInput-root": {
			"& fieldset": {},
			"&:hover fieldset": {
				borderColor: "#ced4da",
			},
		},
	},
	textFieldMUI: {
		borderRadius: theme.shape.borderRadius,
		backgroundColor: theme.palette.background.paper,
		border: "1px solid #ced4da",
		width: "100%",
		padding: "19px",
		transition: theme.transitions.create(["border-color", "box-shadow"]),
		fontFamily: theme.typography.fontFamily,
		fontSize: "18px !important",
		color: theme.palette.text.primary,
		height: "20px!important",
	},
	addButton: {
		minWidth: "35px",
		width: "35px",
		height: "35px",
		padding: "25px",
		fontSize: "1.5rem",
	},
}));
